/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable new-cap */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  DatePicker,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import moment from 'moment';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import Select from 'components/Select';
import FormSubmitControls from 'components/FormSubmitControls';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { getEstadosGlobales, getPeriodicidadesDePagos } from 'api/catalogos/index';
import ModalDelete from 'components/ModalDelete';
import {
  getSubsidios,
  postSubsidio,
  patchSubsidio,
  deleteSubsidio,
  getSubsidio,
} from 'api/estructuraOrganizacional/subsidio';
import { getPermisos } from 'api/usuarios';
import { useDispatch, useSelector } from 'react-redux';
import { selectPermisos } from 'store/catalogos';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { CheckCircleOutlined, CloseCircleOutlined, RedoOutlined } from '@ant-design/icons';
import ModalConfirmation from 'components/ModalConfirmation';
import SubsidioDetalle from './SubsidioDetalle';

export const subsidioPermission = {
  permissionModel: 'subsidio',
  catalogsModels: ['permission'],
};

// eslint-disable-next-line react/prop-types
const Subsidio = ({ permission }) => {
  const dispatch = useDispatch();
  const permisos = useSelector(selectPermisos);
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);
  const [visibleInactivo, setVisibleInactivo] = useState(false);
  const [disableEditar, setDisableEditar] = useState(false);

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getSubsidios();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
        _periodosFiscales,
        _periodos,
        _estados,
      ] = await Promise.all([
        getSubsidios(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodicidadesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
        getEstadosGlobales(),
        getPermisos(dispatch, permisos),
      ]);
      if (mounted) {
        setPeriodosFiscales(_periodosFiscales);
        setPeriodos(_periodos);
        setData(formatReceived(_data));
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setDisableEditar(false);
    setVisibleAutorizar(false);
    setVisibleCancelar(false);
    setVisibleReactivar(false);
    setVisibleInactivo(false);
    form.resetFields();
    setSelectedRowKeys([]);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const subsidio = await getSubsidio(match.id);
    setTimeout(() => {
      if (subsidio) {
        subsidio?.estados_globales !== ESTATUS_ACTIVO ? setDisableEditar(true) : setDisableEditar(false);
        form.resetFields();
        formDatos.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(subsidio));
          formDatos.setFieldsValue(formatReceived(subsidio));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const saved = await (key ? patchSubsidio(key, values) : postSubsidio(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteSubsidio(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setTimeout(() => {
      form.setFieldsValue(record);
    });
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => setVisibleAlert(true);

  const rules = {
    required: [{ required: true }],
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Subsidio ya autorizado');
      }
      const values = data.find((e) => e?.id === key);
      const vals = {
        ...values,
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchSubsidio(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setVisibleAutorizar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Subsidio ya autorizado');
      }
      const values = data.find((e) => e?.id === key);
      const vals = {
        ...values,
        estados_globales: ESTATUS_CANCELADO,
      };
      const res = await patchSubsidio(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setVisibleCancelar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede reactivar un Subsidio ya activo');
      }
      const values = data.find((e) => e?.id === key);
      const vals = {
        ...values,
        estados_globales: ESTATUS_ACTIVO,
      };
      const res = await patchSubsidio(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setVisibleReactivar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Año',
      dataIndex: 'ejercicio',
      key: 'ejercicio',
      render: (val) => periodosFiscales.find((e) => e.id === val)?.periodo,
    },
    {
      titleText: 'Periodicidad de Pago',
      dataIndex: 'periodicidad_de_pago',
      key: 'periodicidad_de_pago',
      render: (val) => periodos.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_del',
      key: 'fecha_del',
      render: (val) => val?.format('YYYY/MM/DD'),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'al',
      key: 'al',
      render: (val) => val?.format('YYYY/MM/DD'),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      render: (val) => estados.find((e) => e?.id === val)?.descripcion,
    },
  ];

  const handleContentPrint = () => {
    const fechaInicial = new Date(form.getFieldValue('fecha_del'));
    const fechaFinal = new Date(form.getFieldValue('al'));
    return `Subsidio del: ${fechaInicial.toLocaleDateString()} al: ${fechaFinal.toLocaleDateString()}`;
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit,
              onClickDelete,
            }}
            disableDelete={
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
              || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
            }
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'subsidio', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
              {
                permission: { model: 'subsidio', action: 'cancelar' },
                onClick: () => setVisibleCancelar(true),
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabledBySelection: false,
                className: 'cancel',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO,
              },
              {
                permission: { model: 'subsidio', action: 'reactivar' },
                onClick: () => setVisibleReactivar(true),
                text: 'Reactivar',
                icon: <RedoOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_ACTIVO,
              },
            ]}
            permission={permission}
            allowExportPDF={false}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Subsidio`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                allowSave={!disableEditar}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={() => onFinish()}
              scrollToFirstError
              initialValues={{ fecha_del: moment().startOf('year') }}
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="ejercicio"
                    rules={rules.required}
                    label="Año"
                    hasFeedback
                  >
                    <Select
                      dataSource={periodosFiscales}
                      labelProp="periodo"
                      keyProp="id"
                      disabled={disableEditar}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_del"
                    label="Fecha Inicial"
                    rules={rules.required}
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled={disableEditar}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="al"
                    rules={rules.required}
                    label="Fecha Final"
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled={disableEditar}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodicidad_de_pago"
                    rules={rules.required}
                    label="Periodicidad de Pago"
                    hasFeedback
                  >
                    <Select
                      dataSource={periodos}
                      disabled={disableEditar}
                    />
                  </Form.Item>
                </Col>
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.required}
                    initialValue={ESTATUS_ACTIVO}
                  >
                    <Select
                      dataSource={estados}
                      disabled={!selectedRowKeys.length || disableEditar}
                      activeInactive={!disableEditar}
                      onChange={(val) => setVisibleInactivo(val === ESTATUS_INACTIVO)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            {selectedRowKeys.length
              ? <SubsidioDetalle permission={permission} selected={selectedRowKeys[0]} disableEditar={disableEditar} /> : null}
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={handleContentPrint()}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setVisibleAutorizar(false);
          }}
          open={visibleAutorizar}
          contentTitle={`Autorizar el ${handleContentPrint()}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          onFinishText="Continuar"
          onCancel={() => {
            setVisibleCancelar(false);
          }}
          open={visibleCancelar}
          title="Confirmación"
          contentTitle={`Cancelar el ${handleContentPrint()}`}
          subMessage="Esta acción no podrá revertirse"
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => {
            setVisibleReactivar(false);
          }}
          open={visibleReactivar}
          title="Confirmación"
          contentTitle={`Reactivar el ${handleContentPrint()}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleInactivo(false);
          }}
          contentTitle={`Inactivar el ${handleContentPrint()}`}
          open={visibleInactivo}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default Subsidio;
